var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('p',[_vm._v("This is an about page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }